import type { WrappedSlideSpec } from '../index.js';

/**
 * A slide plus the question the deck asks of it: does this party have anything to put on it? A
 * thin party is better served by a short honest deck than by twelve slides saying "nothing here".
 */
export type WrappedSlideCandidate = WrappedSlideSpec & {
  readonly when: boolean;
};

export const includedSlides = (
  candidates: readonly WrappedSlideCandidate[],
): readonly WrappedSlideSpec[] =>
  candidates.flatMap((candidate) =>
    candidate.when
      ? [
          {
            id: candidate.id,
            bg: candidate.bg,
            ink: candidate.ink,
            durationMs: candidate.durationMs,
            blobs: candidate.blobs,
            content: candidate.content,
          },
        ]
      : [],
  );
